import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row'
  },
  headermarginBottom: {
    marginBottom: '50px'
  },
  switchWithTextContainer: {
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 12
  },
  buttonRefresh: {
    height: 31
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
}))
export default useStyles
